import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-monthly-milk-abstract',
  templateUrl: './monthly-milk-abstract.component.html',
  styleUrls: ['./monthly-milk-abstract.component.scss']
})
export class MonthlyMilkAbstractComponent implements OnInit {

  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  selected_month: any;

  inp_types: any = ["Month", 'Date Range'];
  selected_inp_type: any = 'Month';

  month_list_for_last_12_months: any = [];
  inp_years: any;
  selected_year: any = null;
  selected_from_date: any = null;
  selected_to_date: any = null;

  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;


  constructor(private httpService: HttpService, private global: GlobalService) {
    // need to move
    this.title = this.global._active_display_name;
    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth() + 1,
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = -1; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth() + 1,
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);

  }

  getClicked() {
    let data_dict = {}
    if (this.selected_inp_type == "Month") {
      data_dict = {
        'selected_inp_type': this.selected_inp_type,
        'selected_year': this.selected_year,
        'selected_month': this.selected_month,
      };
      console.log(data_dict)
    } else {
      data_dict = {
        'selected_inp_type': this.selected_inp_type,
        'selected_from_date': this.selected_from_date,
        'selected_to_date': this.selected_to_date,
        'selected_month': this.selected_month,
      };
    }
    console.log(data_dict);
    this.is_document_available = false;
    this.document_file = null;
    this.httpService.serveMnthlyMilkAbstract(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getDocument() {
    return 'data:application/octet-stream;base64,' + this.document_file['pdf'];
  }

  ngOnInit() {
  }

}
